<div class="banner" [ngClass]="error ? 'error' : 'success'" *ngIf="display">
    <span class="message">{{ message }}</span>
    <span data-id="alert-close-btn" class="close-icon" (click)="onClose()">&#10006;</span>
</div>